module.exports = "/_next/static/pages/test-guidelines/5cc6ed122f4007ddcc6f7b281446dd1d.png";